import { useEffect, useState } from "react";

/**
 * Reemplazo de `useDebouncedValue` de Mantine (mismo shape de
 * retorno: tupla `[valorDebounced]`, se ignora el 2do elemento de Mantine
 * —`{cancel}`— porque ningún call-site del repo lo usaba).
 */
export function useDebouncedValue<T>(value: T, delayMs: number): [T] {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return [debounced];
}
